import { unsafeCSS, html } from "lit";
import { property } from "lit/decorators.js";
import { classMap } from "lit/directives/class-map.js";
import { e } from "../../scoped-registry-mixin-2fqf-E5n.js";
import { LeafElement } from "../../components/leaf-element.js";
const styles = ":host {\n  display: block;\n  flex-grow: 1;\n}\n:host .chc-c-product-card__content {\n  padding: var(--leaf-spacing-32) var(--leaf-spacing-32) 0 var(--leaf-spacing-32);\n  flex-grow: 1;\n}\n:host .chc-c-product-card__content ::slotted([slot=title-default]:not(:empty)) {\n  font-family: var(--leaf-typography-title-default-font-family) !important;\n  font-size: var(--leaf-typography-title-default-font-size) !important;\n  font-weight: var(--leaf-typography-title-default-font-weight) !important;\n  line-height: var(--leaf-typography-title-default-line-height) !important;\n  -webkit-text-decoration: var(--leaf-typography-title-default-text-decoration) !important;\n          text-decoration: var(--leaf-typography-title-default-text-decoration) !important;\n  text-transform: var(--leaf-typography-title-default-text-transform) !important;\n  margin-bottom: var(--leaf-spacing-16) !important;\n}\n:host .chc-c-product-card__content ::slotted([slot=title-small]:not(:empty)) {\n  font-family: var(--leaf-typography-title-small-font-family) !important;\n  font-size: var(--leaf-typography-title-small-font-size) !important;\n  font-weight: var(--leaf-typography-title-small-font-weight) !important;\n  line-height: var(--leaf-typography-title-small-line-height) !important;\n  -webkit-text-decoration: var(--leaf-typography-title-small-text-decoration) !important;\n          text-decoration: var(--leaf-typography-title-small-text-decoration) !important;\n  text-transform: var(--leaf-typography-title-small-text-transform) !important;\n  margin-bottom: var(--leaf-spacing-16) !important;\n}";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
const _CHCProductCardContent = class _CHCProductCardContent extends e(LeafElement) {
  constructor() {
    super(...arguments);
    this.inverted = false;
  }
  render() {
    const componentClassName = {
      "chc-c-product-card__content": true
    };
    return html`<div class=${classMap(componentClassName)}>
      <slot name="title-default"></slot>
      <slot name="title-small"></slot>
      <slot></slot>
    </div>`;
  }
};
_CHCProductCardContent.styles = unsafeCSS(styles);
let CHCProductCardContent = _CHCProductCardContent;
__decorateClass([
  property({ type: Boolean, reflect: true })
], CHCProductCardContent.prototype, "inverted", 2);
export {
  CHCProductCardContent
};
//# sourceMappingURL=product-card-content.component.js.map
